import React from 'react';
import { stencilsThickness } from 'pu-data/SelectOptions';
import SelectComponent from './SelectComponent';


const StencilThickness = (props) => {
  const {
    name,
    options,
  } = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      name={name}
      onChange={onChange}
      required={props.required}
      options={options}
      tooltip={props.tooltip}
      selected={props.parameters[name] || ''}
      groupName={props.groupName}
      inputClassName={props.inputClassName}
      errorMessage={props.errorMessage} />
  );
};

StencilThickness.defaultProps = {
  options: stencilsThickness,
  label: 'Stencil Thickness',
  name: 'material_thickness',
};

export default StencilThickness;
